/**
 * Generated bundle index. Do not edit.
 */

export {TpAudioEditorModule} from './public_api';

export {DragAndDropDirective as ɵb} from './src/app/tp-audio-editor/drag-and-drop.directive';
export {TpAudioEditorComponent as ɵa} from './src/app/tp-audio-editor/tp-audio-editor.component';